/* Hero slideshow JS */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (el) {
    var slides    = Array.prototype.slice.call(el.querySelectorAll('[data-hero-slide]'));
    var dots      = Array.prototype.slice.call(el.querySelectorAll('[data-hero-dot]'));
    var btnPrev   = el.querySelector('[data-hero-prev]');
    var btnNext   = el.querySelector('[data-hero-next]');
    var autoplay  = el.getAttribute('data-autoplay') !== 'false';
    var speed     = parseInt(el.getAttribute('data-autoplay-speed'), 10) || 5000;
    var current   = 0;
    var timer     = null;

    if (!slides.length) return;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected','false'); }
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected','true'); }
    }

    function startTimer() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }

    function stopTimer() { clearInterval(timer); }

    /* Dot clicks */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-hero-dot'), 10));
        stopTimer(); startTimer();
      });
    });

    /* Arrow buttons */
    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        goTo(current - 1); stopTimer(); startTimer();
      });
    }
    if (btnNext) {
      btnNext.addEventListener('click', function () {
        goTo(current + 1); stopTimer(); startTimer();
      });
    }

    /* Pause on hover */
    el.addEventListener('mouseenter', stopTimer);
    el.addEventListener('mouseleave', startTimer);

    /* Touch swipe */
    var tx = 0;
    el.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; stopTimer(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var diff = tx - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { diff > 0 ? goTo(current + 1) : goTo(current - 1); }
      startTimer();
    });

    startTimer();
  });
});
